module.exports = __webpack_public_path__ + "img/association-road-4.72433315.png";